/* Cookbook carousel -- the ring component for sections/cookbook-recipes.liquid.
   Kept as an asset rather than inline so it is cached once and the section
   file stays readable. Loaded synchronously by the section, which must happen
   before Alpine walks the DOM and evaluates x-data. */
/* Registered once on window rather than per section: the page may hold more
   than one cookbook block, and each gets its own state from its x-data call. */
(function () {
  'use strict';
  if (window.cookbookRing) return;

  var FLAVOURS = ['Original', 'Verde', 'Yuzu'];

  window.cookbookRing = function (cfg) {
    return {
      tabs: cfg.tabs,
      tab: cfg.start,
      items: cfg.items,
      autoplayMs: cfg.autoplayMs,
      resumeMs: cfg.resumeMs,
      idx: {},
      timer: null,
      resumeTimer: null,
      dragX: null,
      dragY: null,
      swiped: false,
      reduced: false,

      init: function () {
        var self = this;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reset();
        if (!this.reduced) this.play();
        /* A carousel ticking away in a background tab is wasted work and
           lands the visitor on an arbitrary slide when they return. */
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) self.stop();
          else if (!self.reduced && !self.resumeTimer) self.play();
        });
      },

      /* ---- data ---- */
      list: function (flavour) {
        var t = this.tab;
        return this.items.filter(function (i) { return i.flavour === flavour && i.tab === t; });
      },
      count: function (flavour) { return this.list(flavour).length; },

      reset: function () {
        var o = {}, i;
        for (i = 0; i < FLAVOURS.length; i++) o[FLAVOURS[i]] = 0;
        /* Also one position per flavour the items actually carry. The Trio and
           bundle pages pass every recipe tagged 'All', and with no 'All' key
           idx['All'] was undefined: every offset came out NaN, so all cards
           were hidden and the ring never moved. */
        for (i = 0; i < this.items.length; i++) o[this.items[i].flavour] = 0;
        this.idx = o;
      },

      /* ---- tabs ---- */
      setTab: function (t) {
        if (this.tab === t) return;
        this.tab = t;
        this.reset();
        this.bump();
      },
      moveTab: function (d) {
        var i = this.tabs.indexOf(this.tab);
        var n = this.tabs[(i + d + this.tabs.length) % this.tabs.length];
        this.setTab(n);
        var self = this;
        this.$nextTick(function () {
          var btns = self.$root.querySelectorAll('[role="tab"]');
          var target = btns[self.tabs.indexOf(n)];
          if (target) target.focus();
        });
      },

      /* ---- ring geometry ----
         Shortest signed distance from the active index, wrapped. This is what
         makes the carousel loop without cloned nodes and behave at any count.
         Returns null when the card is not in the current tab/flavour at all.

         None of this runs on the All tab: that view is a plain grid rendered
         straight from Liquid, with no ring, no autoplay and no active index. */
      offset: function (id, flavour) {
        var l = this.list(flavour), n = l.length;
        if (!n) return null;
        var pos = -1;
        for (var i = 0; i < n; i++) { if (l[i].id === id) { pos = i; break; } }
        if (pos < 0) return null;
        var a = this.idx[flavour] % n;
        var half = Math.floor(n / 2);
        return ((pos - a + n + half) % n) - half;
      },
      onStage: function (id, flavour) {
        var d = this.offset(id, flavour);
        return d !== null && Math.abs(d) <= 2;
      },
      isActive: function (id, flavour) { return this.offset(id, flavour) === 0; },
      isFar: function (id, flavour) {
        var d = this.offset(id, flavour);
        return d !== null && Math.abs(d) === 2;
      },
      cardStyle: function (id, flavour) {
        var d = this.offset(id, flavour);
        if (d === null) return 'display:none;';
        var s = d === 0 ? 1 : 0.58;
        var z = d === 0 ? 3 : (Math.abs(d) === 1 ? 2 : 1);
        return 'transform: translateX(calc(var(--ck-step) * ' + d + ')) scale(' + s + '); z-index:' + z + ';';
      },
      activeName: function (flavour) {
        var l = this.list(flavour);
        if (!l.length) return '';
        return l[this.idx[flavour] % l.length].name;
      },
      emptyLine: function () {
        return 'More ' + this.tab.charAt(0).toUpperCase() + this.tab.slice(1) + ' recipes are on the way.';
      },

      /* ---- movement ---- */
      step: function (flavour, d) {
        var n = this.count(flavour);
        if (n < 2) return;
        this.idx[flavour] = ((this.idx[flavour] + d) % n + n) % n;
        this.bump();
      },
      advance: function () {
        /* Every key in idx, not just the three sauces, or an 'All' ring
           would be seeded but never advance. */
        var keys = Object.keys(this.idx);
        for (var i = 0; i < keys.length; i++) {
          var f = keys[i], n = this.count(f);
          if (n > 1) this.idx[f] = (this.idx[f] + 1) % n;
        }
      },
      play: function () {
        var self = this;
        this.stop();
        /* No carousel exists on the All tab, so a timer there would spin
           every autoplayMs doing nothing. All is the default tab, so that
           would otherwise be the common case. */
        if (this.reduced || this.tab === 'all') return;
        this.timer = setInterval(function () { self.advance(); }, this.autoplayMs);
      },
      stop: function () { clearInterval(this.timer); this.timer = null; },

      /* Any deliberate interaction stops the rotation, which only resumes
         after resumeMs of quiet -- otherwise it fights the visitor. */
      bump: function () {
        var self = this;
        this.stop();
        clearTimeout(this.resumeTimer);
        if (this.reduced) { this.resumeTimer = null; return; }
        this.resumeTimer = setTimeout(function () {
          self.resumeTimer = null;
          self.play();
        }, this.resumeMs);
      },

      /* ---- pointer ---- */
      down: function (e) { this.dragX = e.clientX; this.dragY = e.clientY; },
      up: function (e, flavour) {
        if (this.dragX === null) return;
        var dx = e.clientX - this.dragX, dy = e.clientY - this.dragY;
        this.dragX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          /* Mark the gesture so the click it also fires cannot navigate. */
          var self = this;
          this.swiped = true;
          setTimeout(function () { self.swiped = false; }, 60);
          this.step(flavour, dx < 0 ? 1 : -1);
        }
      },
      tap: function (id, flavour, e) {
        if (this.swiped) { e.preventDefault(); return; }
        if (!this.isActive(id, flavour)) {
          /* A side card centres itself rather than navigating -- clicking a
             thing you can barely see and being taken away is a trap. */
          e.preventDefault();
          var l = this.list(flavour);
          for (var i = 0; i < l.length; i++) {
            if (l[i].id === id) { this.idx[flavour] = i; break; }
          }
          this.bump();
          return;
        }
        var el = e.currentTarget;
        el.classList.add('is-pressed');
        setTimeout(function () { el.classList.remove('is-pressed'); }, 260);
        var href = el.getAttribute('href');
        if (!href || href === '#') e.preventDefault();
      }
    };
  };
})();
